import { render } from "./RecordRestrictionFields.vue?vue&type=template&id=366c7af2"
import script from "./RecordRestrictionFields.vue?vue&type=script&lang=js"
export * from "./RecordRestrictionFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
